module.exports = require("ember-tracked-storage-polyfill");